import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { StorageMap } from '@ngx-pwa/local-storage';
import { AngularFireAuth } from '@angular/fire/auth';


@Injectable()
export class SignOutGuard implements CanActivate {

  constructor(private authService: AngularFireAuth,
              private router: Router,
              private storage: StorageMap) {
  }

  canActivate(next: ActivatedRouteSnapshot,
              state: RouterStateSnapshot): Observable<boolean> {

    return this.authService.user
      .pipe(
        map(user => {
          if (!user) {
            this.storage.clear().subscribe();
            this.router.navigateByUrl('login')
              .then(() => window.location.reload());
            return false;
          }
          if (user) {
            this.authService.signOut()
              .then(() => {
                // Clear indexDB
                return Promise.resolve(this.storage.clear().subscribe())
              })
              // Reroute to login
              .then(() => this.router.navigateByUrl('login'))
              .then(() => {
                // reload page
                window.location.reload();
                return false;
              });
          }
        })
      );
  }
}
